// tslint:disable
/**
 * Course API
 * Used for: - Manage courses - Manage course info - Manage students - Learning control 
 *
 * The version of the OpenAPI document: 2.6.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface LearningUnit
 */
export interface LearningUnit {
    /**
     * 
     * @type {string}
     * @memberof LearningUnit
     */
    id: string;
    /**
     * **DEPRECATED!**
     * @type {string}
     * @memberof LearningUnit
     */
    iri: string;
    /**
     * 
     * @type {string}
     * @memberof LearningUnit
     */
    objectType: LearningUnitObjectTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LearningUnit
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof LearningUnit
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof LearningUnit
     */
    parentId?: string;
    /**
     * 
     * @type {number}
     * @memberof LearningUnit
     */
    sort: number;
    /**
     * **DEPRECATED!** Always empty list.
     * @type {Array<string>}
     * @memberof LearningUnit
     */
    objectives: Array<string>;
    /**
     * Additional metadata
     * @type {object}
     * @memberof LearningUnit
     */
    metadata?: object;
    /**
     * 
     * @type {Date}
     * @memberof LearningUnit
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof LearningUnit
     */
    updatedAt: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum LearningUnitObjectTypeEnum {
    Lesson = 'Lesson',
    Block = 'Block'
}



